var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 30.642,
    viewBox: "0 0 40 30.642",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_344",
    "data-name": "Rectangle 344",
    width: 40,
    height: 30.642,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_287-2",
    "data-name": "Group 287",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M30.046,1.8V28.044c-.127.317-.115.685-.382.952-.112.112-.2.233-.372.253-.293-.013-.457-.233-.638-.415q-6.29-6.292-12.583-12.582l-.887-.89a.8.8,0,0,1-.253-.432c0-.272.215-.408.377-.57q3.218-3.215,6.433-6.435Q25.206,4.46,28.673.994c.175-.175.332-.377.608-.4.375.1.518.4.635.72a3.786,3.786,0,0,0,.13.485",
    transform: "translate(9.954 0.398)",
    fill: "#f98317"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M12.151.013C12.713.008,13.274,0,13.836,0q7.4,0,14.787,0a3.364,3.364,0,0,1,2.622,1.088c-.107.1-.217.187-.318.288Q24.113,8.187,17.3,15c-.1.1-.192.213-.288.32a.752.752,0,0,1-.24.475c-.857.847-1.695,1.708-2.56,2.547a2.684,2.684,0,0,1-1.487.818c-.27.038-.558.09-.7-.247a1.93,1.93,0,0,1-.06-.662q0-8.715,0-17.428c0-.277-.083-.587.185-.807",
    transform: "translate(7.969 0)",
    fill: "#ffc01c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M12.149,12.888A2.61,2.61,0,0,0,14.167,12q1.425-1.4,2.845-2.813c.105.115.2.238.315.348q6.785,6.785,13.572,13.57c.11.11.233.207.352.31a3.341,3.341,0,0,1-2.62,1.1q-7.437,0-14.873,0c-.537,0-1.072-.008-1.608-.013-.228-.168-.183-.42-.185-.648-.01-1.373,0-2.747,0-4.12,0-2.028,0-4.055,0-6.082a1.086,1.086,0,0,1,.122-.72l.065-.043",
    transform: "translate(7.971 6.126)",
    fill: "#fc9420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M1.027,29.138A3.541,3.541,0,0,1,0,26.438Q0,16.668,0,6.9C0,5.681,0,4.465.005,3.248A3.428,3.428,0,0,1,1.032.668a.319.319,0,0,1,.4.057c.1.087.19.18.282.272,2.848,2.847,5.668,5.72,8.552,8.528,1.628,1.587,3.23,3.2,4.85,4.795.163.162.373.307.328.588-.015.252-.208.383-.363.538q-5.2,5.2-10.4,10.4c-1.028,1.027-2.05,2.058-3.08,3.08-.153.153-.3.357-.567.208",
    transform: "translate(0 0.415)",
    fill: "#fc9420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M14.917,15.319a.69.69,0,0,0-.267-.377Q7.805,8.14.96,1.342a1.013,1.013,0,0,0-.34-.26A3.224,3.224,0,0,1,3.063.011c5.548-.015,11.1,0,16.645,0v19a.429.429,0,0,1-.463.113,2.873,2.873,0,0,1-1.452-.8c-.887-.863-1.752-1.748-2.632-2.618a1.33,1.33,0,0,1-.245-.393",
    transform: "translate(0.413 0.002)",
    fill: "#ffd12b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M14.919,9.193a.774.774,0,0,1,.4.292q1.262,1.257,2.52,2.517a2.878,2.878,0,0,0,1.868.885q0,5.808,0,11.615c-.638,0-1.282.012-1.923.012q-7.2,0-14.412,0A3.547,3.547,0,0,1,.616,23.425a.869.869,0,0,0,.373-.277Q7.839,16.3,14.683,9.456c.083-.083.157-.175.237-.263",
    transform: "translate(0.411 6.128)",
    fill: "#ffc01c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon_mail.0b437f591754a573e64cd64f992a4b52.svg";
export { ForwardRef as ReactComponent };